module.exports = __webpack_public_path__ + "static/img-slide-4-es-4990b27dfca141a6529d9df1ca1b09b8.png";